import e from "react";
var n = function n(_n, o) {
  return "function" == typeof _n ? _n(o) : e.cloneElement(_n, o);
};
export { n as cloneAndRender };